<template>
  <div class="PanelCompany">
    <!-- Paginación superior -->
    <div class="pagination-container top">
      <v-pagination
        v-model="ppage"
        width="100%"
        :length="llength"
        :total-visible="4"
        color="blue"
        @update:modelValue="onPageChange"
      />
    </div>

    <!-- Cards de compañías -->
    <v-card class="card-companies">
      <ComponentCompany
        v-for="company in companies"
        :key="company.idCompany"
        :company="company"
      />
    </v-card>

    <!-- Paginación inferior -->
    <div class="pagination-container bottom">
      <v-pagination
        v-model="ppage"
        width="100%"
        :length="llength"
        :total-visible="4"
        color="blue"
        @update:modelValue="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import ComponentCompany from './ComponentCompany.vue'

export default {
  name: 'PanelCompany',
  components: { ComponentCompany },
  props: {
    page: {
      type: Number,
      required: true
    },
    length: {
      type: Number,
      required: true
    },
    companies: {
      type: Array,
      required: true
    }
  },
  emits: ['onPageChange'],
  data() {
    return {
      ppage: this.page,
      llength: this.length
    }
  },
  watch: {
    page(newVal) {
      this.ppage = newVal
    },
    length(newVal) {
      this.llength = newVal
    }
  },
  methods: {
    onPageChange() {
      this.$emit('onPageChange', this.ppage)
    }
  }
}
</script>

<style scoped>
.PanelCompany {
  background-color: #2d2d2d !important;
}

/* Contenedor de paginación */
.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  background-color: #1e1e1e;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
}

.pagination-container.bottom {
  margin-top: 10px;
  padding-bottom: 25px;
}

/* Estilos de Vuetify Pagination */
.v-pagination {
  background-color: transparent;
}

.v-pagination__item {
  background-color: #2d2d2d !important;
  color: #fff !important;
  border: 1px solid #3a3a3a !important;
}

.v-pagination__item--active {
  background-color: #1976d2 !important;
  color: #fff !important;
}

/* Cards: una columna en celular y va abriendo columnas al crecer.
   Con grid las tarjetas de una misma fila quedan del mismo alto solas,
   que con el flex de antes habia que forzarlo. */
.card-companies {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  padding: 16px 12px 24px;
  background-color: #242424;
  box-shadow: none;
}

@media (min-width: 600px) {
  .card-companies {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 960px) {
  .card-companies {
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
    padding: 24px;
  }
}
</style>
